import { type ApiResponse } from '@abaninja/types';
import { httpClient } from '@abaninja/util-http-client';
import { createCancellablePromise } from '@abaninja/util-store';

import type { Account } from './@types';

export function getAccounts() {
  return createCancellablePromise(({ signal }) => httpClient.get<ApiResponse<Account[]>>('/users/v1/me/accounts', { signal }));
}
